import { render, staticRenderFns } from "./SubBrand.vue?vue&type=template&id=d0e0adc6&"
import script from "./SubBrand.vue?vue&type=script&lang=js&"
export * from "./SubBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports